<template>
  <div class="row d-flex flex-row h-100">
    <auth-left-container> </auth-left-container>
    <div
      class="right-container bg-extra-light-gray p-4 d-flex flex-column justify-content-center align-items-center text-black"
    >
      <div class="center-form">
        <h2 class="mb-4" style="font-weight: bold;">
          Enter the <span class="text-primary">Code</span> we just sent you
        </h2>
        <form class="form-action" @submit.prevent="resetPassword">
          <b-form-group :invalid-feedback="error" :state="error.length == 0">
            <code-input
              className="code-input-container"
              :loading="false"
              :fields="codeLength"
              class="input"
              v-on:change="onChange"
            />
          </b-form-group>
          <b-form-group>
            <input type="checkbox" id="remember-device" v-model="remember" />
            <label for="remember-device" class="ml-2">
              Remember this device
            </label>
          </b-form-group>
          <b-button
            :disabled="code.length != codeLength"
            type="submit"
            variant="primary"
            class="auth-button w-100"
            style="margin-top: 20px;"
          >
            LOGIN
          </b-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CodeInput from "vue-verification-code-input";
import serverAuth from "../../server/auth";
import { setToken, setTFAToken } from "../../helpers/session";
import AuthLeftContainer from "./AuthLeftContainer.vue";

export default {
  name: "AuthTwoFactorAuth",
  components: {
    AuthLeftContainer,
    CodeInput
  },
  data() {
    return {
      codeLength: 4,
      key: this.$route.params.key,
      code: "",
      error: "",
      remember: false
    };
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async resetPassword() {
      this.error = "";
      const authResult = await serverAuth.twoFactorAuth({
        code: this.code,
        key: this.key
      });
      if (authResult.errorCode) this.error = authResult.message;
      else {
        if (this.remember && authResult.twoFactorAuthToken) {
          setTFAToken(authResult.twoFactorAuthToken);
        }

        await setToken(authResult.token);
        localStorage.setItem("inactivityBegin", Math.floor(Date.now() / 1000));
        this.$router.push("/");
      }
    },
    onChange(v) {
      this.code = v;
    }
  }
};
</script>
<style scoped>
.right-container {
  width: 50%;
}
.center-form {
  padding: 0px 15%;
}
.form-action {
  max-width: 400px;
  min-width: 400px;
}
</style>
